import { Editor, Element, Node, Path, Range, Transforms } from 'slate';
import { ExcludeElement } from 'slate/types/slate';
import { isTag } from './navigation';

export const isExclude = (n: Node): n is ExcludeElement => Element.isElement(n) && n.type === 'exclude';

export function insertExclude(editor: Editor): void {
  if (!editor.selection || Range.isCollapsed(editor.selection)) return;
  Transforms.wrapNodes(editor, { type: 'exclude', children: [] }, { split: true, at: editor.selection });
}

export function removeExclude(editor: Editor, at: Path): void {
  Transforms.unwrapNodes(editor, { at, match: isExclude });
}

export function convertTagToExclude(editor: Editor, tagId: string): boolean {
  const entry = Array.from(Editor.nodes(editor, { at: [], match: (n) => isTag(n) && n.tagId === tagId }))[0];
  if (!entry) return false;
  const [, path] = entry;
  Transforms.setNodes(editor, { type: 'exclude' } as Partial<ExcludeElement>, { at: path });
  Transforms.unsetNodes(editor, ['tagId', 'tagType', 'continuedAt'], { at: path });
  return true;
}
